import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { StoreContext } from "components/StoreContext";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "react-accessible-accordion/dist/fancy-example.css";

const CourseTabs = ({ courseId }) => {
  const { store, StoreAPI } = useContext(StoreContext);
  const [product, setProduct] = useState({
    author: "",
    creditInfo: "",
    courseOutline: "",
    learningObjectives: ""
  });

  useEffect(() => {
    if (store.loaded) {
      StoreAPI.get(`products/${courseId}/bundle`)
        .then(response => {
          const { data } = response;
          const obj = {
            author: data[0].author,
            creditInfo: data[0].creditInfo,
            courseOutline: data[0].courseOutline,
            learningObjectives: data[0].learningObjectives
          };
          setProduct(obj);
        })
        .catch(error => {
          console.log(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.loaded, courseId]);

  return (
    <>
      <div className="courseTabs">
        <Tabs>
          <TabList>
            {product && product.learningObjectives && (
              <Tab>Learning Objectives</Tab>
            )}
            {product && product.author && <Tab>Author Information</Tab>}
            {product && product.creditInfo && <Tab>CE Accreditation</Tab>}
            {product && product.courseOutline && <Tab>Course Outline</Tab>}
          </TabList>
          {product && product.learningObjectives && (
            <TabPanel>
              <p
                dangerouslySetInnerHTML={{
                  __html: product.learningObjectives
                }}
              />
            </TabPanel>
          )}
          {product.author && (
            <TabPanel>
              <p
                dangerouslySetInnerHTML={{
                  __html: product.author
                }}
              />
            </TabPanel>
          )}
          {product && product.creditInfo && (
            <TabPanel>
              <p
                dangerouslySetInnerHTML={{
                  __html: product.creditInfo
                }}
              />
            </TabPanel>
          )}
          {product && product.courseOutline && (
            <TabPanel>
              <p
                dangerouslySetInnerHTML={{
                  __html: product.courseOutline
                }}
              />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  );
};

CourseTabs.propTypes = {
  courseId: PropTypes.number
};
CourseTabs.defaultProps = {
  courseId: null
};

export default CourseTabs;
